import { HttpService } from "./http.service";
import { RequestInputOutputParamsModel } from "../models/requestInputOutputParams.model";
import { ResultRequestModel } from "../models/resultRequest.model";

const basePath = "/ForeCast";
const request = HttpService.handleRequest();

export const ForeCastService = {
  getList,
  getInconsistentList,
  getCollectionScheduleList,
  pendingEquipmentPickupApproval,
  getEquipmentSchedulePickupList
};

async function getList(data: RequestInputOutputParamsModel): Promise<ResultRequestModel> {
  return request.post(`${basePath}/EquipmentDashAnalyticalListWithPagination`, data);
}

async function getInconsistentList(data: RequestInputOutputParamsModel): Promise<ResultRequestModel> {
  return request.post(`${basePath}/InconsistentForecastWithPagination`, data)
}

async function getCollectionScheduleList(data: RequestInputOutputParamsModel): Promise<ResultRequestModel> {
  return request.post(`${basePath}/CollectionScheduleForecastWithPagination`, data)
}

async function pendingEquipmentPickupApproval(data: RequestInputOutputParamsModel): Promise<ResultRequestModel> {
  return request.post(`${basePath}/PendingEquipmentPickupApprovalForecastWithPagination`, data)
}

async function getEquipmentSchedulePickupList(data: RequestInputOutputParamsModel): Promise<ResultRequestModel> {
  return request.post(`${basePath}/EquipmentSchedulePickupForecastWithPagination`, data)
}


export default ForeCastService;

